import { Component } from '@angular/core';

/**
 * Renders the inbox inside mailbox
 */
@Component({
  templateUrl: './inbox.component.html',
  styleUrls: ['./inbox.component.scss'],
})
export class InboxComponent {
  nyanCat = require('../../../../assets/demo/Nyan_cat_250px_frame.jpg');
}



// WEBPACK FOOTER //
// ./src/app/mailbox/inbox/inbox.component.ts